import { useState, useEffect } from "react";
import Select from "react-select";
import DataFetcherTemplate from "../../hooks/fetchTemplate";

const facultadSlugMap = {
  empresas: "Ciencias Económicas y Empresariales",
  exactas: "Ciencias Exactas y Naturales",
  salud: "Ciencias de la Salud",
  sociales: "Ciencias Sociales, Educación y Humanidades",
  juridicas: "Ciencias Jurídicas y Políticas",
  ingenieria: "Ingenierías y Arquitectura",
  negocios: "UTPL Escuela de Negocios",
};

const facultadNameToSlug = Object.fromEntries(
  Object.entries(facultadSlugMap).map(([slug, name]) => [name, slug])
);

function OfferPosgrados() {
  const optionsPrograma = [
    { value: "todos", label: "Todos los programas" },
    { value: "Maestría", label: "Maestría" },
    { value: "Especialización", label: "Especialización" },
    { value: "Doctorado", label: "Doctorado" },
  ];

  const optionsFacultad = [
    { value: "todos", label: "Toda la oferta" },
    {
      value: "Ciencias Económicas y Empresariales",
      label: "Ciencias Económicas y Empresariales",
    },
    {
      value: "Ciencias Exactas y Naturales",
      label: "Ciencias Exactas y Naturales",
    },
    { value: "Ciencias de la Salud", label: "Ciencias de la Salud" },
    {
      value: "Ciencias Sociales, Educación y Humanidades",
      label: "Ciencias Sociales, Educación y Humanidades",
    },
    {
      value: "Ciencias Jurídicas y Políticas",
      label: "Ciencias Jurídicas y Políticas",
    },
    {
      value: "Ingenierías y Arquitectura",
      label: "Ingenierías y Arquitectura",
    },
    {
      value: "UTPL Escuela de Negocios",
      label: "UTPL Escuela de Negocios",
    },
  ];

  const optionsModalidad = [
    { value: "todos", label: "Todas las modalidades" },
    { value: "En línea", label: "En línea" },
    { value: "Presencial", label: "Presencial" },
  ];

  const getInitialValue = (param, options) => {
    const params = new URLSearchParams(window.location.search);
    let value = params.get(param);

    if (param === "facultad" && facultadSlugMap[value]) {
      value = facultadSlugMap[value];
    }

    return options.find((o) => o.value === value) || options[0];
  };

  const [programaSeleccionado, setProgramaSeleccionado] = useState(
    getInitialValue("programa", optionsPrograma)
  );

  const [facultadSeleccionada, setFacultadSeleccionada] = useState(
    getInitialValue("facultad", optionsFacultad)
  );

  const [modalidadSeleccionada, setModalidadSeleccionada] = useState(
    getInitialValue("modalidad", optionsModalidad)
  );

  useEffect(() => {
    const params = new URLSearchParams();

    if (programaSeleccionado.value !== "todos")
      params.set("programa", programaSeleccionado.value);

    if (facultadSeleccionada.value !== "todos") {
      const slug = facultadNameToSlug[facultadSeleccionada.value];
      params.set("facultad", slug);
    }

    if (modalidadSeleccionada.value !== "todos")
      params.set("modalidad", modalidadSeleccionada.value);

    const newUrl =
      window.location.pathname +
      (params.toString() ? `?${params.toString()}` : "");

    window.history.replaceState({}, "", newUrl);
  }, [programaSeleccionado, facultadSeleccionada, modalidadSeleccionada]);

  const limpiarFiltros = () => {
    setProgramaSeleccionado(optionsPrograma[0]);
    setFacultadSeleccionada(optionsFacultad[0]);
    setModalidadSeleccionada(optionsModalidad[0]);
  };

  const DataDisplayOferta = ({ data }) => {
    const filteredData = data.filter((item) => {
      const matchPrograma =
        programaSeleccionado.value === "todos" ||
        item.field_programa?.includes(programaSeleccionado.value);

      const matchFacultad =
        facultadSeleccionada.value === "todos" ||
        item.field_area?.includes(facultadSeleccionada.value);

      const modalidad =
        item.field_modalidad?.[0] || item.field_modalidad_carrera?.[0] || "";

      const matchModalidad =
        modalidadSeleccionada.value === "todos" ||
        modalidad.includes(modalidadSeleccionada.value);

      return matchPrograma && matchFacultad && matchModalidad;
    });

    return (
      <>
        <div className="wrapper-filtros layout9">
          <div>
            <p><b>Programa</b></p>
            <Select
              options={optionsPrograma}
              value={programaSeleccionado}
              onChange={setProgramaSeleccionado}
            />
          </div>

          <div>
            <p><b>Facultad</b></p>
            <Select
              options={optionsFacultad}
              value={facultadSeleccionada}
              onChange={setFacultadSeleccionada}
            />
          </div>

          <div>
            <p><b>Modalidad</b></p>
            <Select
              options={optionsModalidad}
              value={modalidadSeleccionada}
              onChange={setModalidadSeleccionada}
            />
          </div>

          <div>
            <button className="btn-reset-filtros" onClick={limpiarFiltros}>
              Limpiar filtros
            </button>
          </div>
        </div>

        <div className="layout9">
          <p className="contador-resultados">
            {filteredData.length} programas encontrados
          </p>
        </div>

        <div className="wrapper-academicoffer margin">
          {filteredData.map((item, index) => (
            <div key={index}>
              <div className="programa-imagen">
                <img src={item.field_portada} alt={item.title} />
              </div>

              <div className="layout8">
                <div className="flex">
                  <p className="tipoposgrado">{item.field_programa}</p>

                  {item.field_tag?.[0] && (
                    <p className="tag-2">{item.field_tag}</p>
                  )}
                </div>

                <h3>{item.title}</h3>

                {item.field_modalidad?.[0] && (
                  <p>
                    <b>Modalidad:</b> {item.field_modalidad}
                  </p>
                )}

                {item.field_posgrado_duracion && (
                  <p>
                    <b>Duración:</b> {item.field_posgrado_duracion}
                  </p>
                )}

                {item.field_posgrado_campo && (
                  <p>
                    <b>Campo del conocimiento:</b> {item.field_posgrado_campo}
                  </p>
                )}

                {item.field_area?.[0] && (
                  <p>
                    <b>Facultad:</b> {item.field_area}
                  </p>
                )}

                {item.field_inicio?.[0] && (
                  <p>
                    <b>Inicio de clases:</b> {item.field_inicio}
                  </p>
                )}

                {item.field_enlace_contenido?.[0] && (
                  <div className="wrapper-link">
                    <a
                      className="link-offer"
                      href={item.field_enlace_contenido}
                      rel="noreferrer"
                    >
                      Ver programa
                      <span className="material-icons">
                        arrow_forward_ios
                      </span>
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </>
    );
  };

  return (
    <DataFetcherTemplate url="https://utpl.edu.ec/maestrias/services/posgrados.json">
      {(data) => <DataDisplayOferta data={data} />}
    </DataFetcherTemplate>
  );
}

export default OfferPosgrados;